import { render, staticRenderFns } from "./TransferTeamFileDialog.vue?vue&type=template&id=4dd3eaec&scoped=true&"
import script from "./TransferTeamFileDialog.vue?vue&type=script&lang=js&"
export * from "./TransferTeamFileDialog.vue?vue&type=script&lang=js&"
import style0 from "./TransferTeamFileDialog.vue?vue&type=style&index=0&id=4dd3eaec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd3eaec",
  null
  
)

export default component.exports